import React from "react";

import { TableCell, TableRow } from "@mui/material";

import { Dataset } from "../../../api/types/datasets";

import { EditedField } from "./DatasetsTable";
import { DatasetUpdate } from "./DatasetUpdate";
import { OwnerUpdate } from "./OwnerUpdate";

export type RegionsTableRowProps = {
  data: Dataset;
  onEdit: (row: Dataset, column: string) => void;
  onCancel: () => void;
  onSave: (data: {
    id?: number | undefined | null;
    name?: string | undefined | null;
    owner?: string | null;
  }) => void;
  editedField: EditedField | null | undefined;
};

export function DatasetsTableRow({
  data,
  onEdit,
  onCancel,
  onSave,
  editedField,
}: RegionsTableRowProps) {
  return (
    <TableRow sx={{ height: "73px" }}>
      <TableCell>
        <div className="flex flex-row gap-4 items-start justify-between">
          <DatasetUpdate
            data={data}
            onEdit={onEdit}
            editMode={
              editedField?.row === data.Id && editedField?.column === "dataset"
            }
            onSave={onSave}
            onCancel={onCancel}
          />
        </div>
      </TableCell>
      <TableCell>
        <div className="flex flex-row gap-4 items-start justify-between">
          <OwnerUpdate
            data={data}
            onEdit={onEdit}
            editMode={
              editedField?.row === data.Id && editedField?.column === "owner"
            }
            onSave={onSave}
            onCancel={onCancel}
          />
        </div>
      </TableCell>
    </TableRow>
  );
}
